var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 16.25V20.5833C25.875 21.158 25.6204 21.7091 25.1672 22.1154C24.714 22.5217 24.0993 22.75 23.4583 22.75H6.54167C5.90073 22.75 5.28604 22.5217 4.83283 22.1154C4.37961 21.7091 4.125 21.158 4.125 20.5833V16.25M8.95833 10.8333L15 16.25M15 16.25L21.0417 10.8333M15 16.25V3.25",
    stroke: "#0DACF5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0e113bb70d7bd7135a8ecb9ee80ee058.svg";
export { ForwardRef as ReactComponent };